import { useEffect, useState } from "react";
import { toast } from "sonner";
import { House, Envelope, CaretDown, CaretUp } from "@phosphor-icons/react";
import { DashboardLayout } from "../components/layout/DashboardLayout";
import { BackofficeNotificationBell } from "../components/layout/BackofficeNotificationBell";
import { formatET } from "../lib/dateUtils";
import { api, formatApiErrorDetail } from "../lib/api";

const navItems = [
  { to: "/backoffice", label: "Weekly Report", icon: <House size={18} weight="duotone" />, testId: "nav-backoffice-form" },
  { to: "/backoffice/trust-intake", label: "Trust Intake", icon: <Envelope size={18} weight="duotone" />, testId: "nav-backoffice-trust-intake" },
];

export default function BackofficeTrustIntakePage() {
  const [submissions, setSubmissions] = useState([]);
  const [expandedRaw, setExpandedRaw] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchSubmissions = () => {
    api.get("/backoffice/trust-intake-submissions")
      .then(({ data }) => setSubmissions(data))
      .catch((e) => toast.error(formatApiErrorDetail(e.response?.data?.detail)))
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchSubmissions(); }, []);

  const toggleRaw = (id) => {
    setExpandedRaw((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  };

  return (
    <DashboardLayout navItems={navItems} moduleName="Trust Intake" topRight={<BackofficeNotificationBell />}>
      <div className="max-w-3xl mx-auto" data-testid="backoffice-trust-intake-page">
        <h1 className="font-serif text-2xl text-igc-cream mb-1">Trust Intake Submissions</h1>
        <p className="text-igc-muted text-sm mb-8">Live submissions from the public trust intake form — arrives here automatically the moment someone submits.</p>
        {!loading && submissions.length === 0 && <p className="text-igc-muted text-sm" data-testid="backoffice-trust-intake-empty">No website intake submissions received yet.</p>}
        <div className="space-y-3">
          {submissions.map((s) => (
            <div key={s.id} className="bg-igc-surface border border-igc-gold/15 p-5" data-testid={`backoffice-trust-intake-submission-${s.id}`}>
              <div className="flex items-center justify-between gap-4 flex-wrap mb-1">
                <p className="text-igc-cream text-sm">{s.name || "(No name provided)"} <span className="text-igc-muted text-xs">{s.email && `— ${s.email}`} {s.phone && `— ${s.phone}`}</span></p>
                <p className="text-igc-muted text-xs">{formatET(s.received_at, "MMM d, yyyy h:mm a")}</p>
              </div>
              {s.message && <p className="text-igc-muted text-sm mt-1">{s.message}</p>}
              <button data-testid={`backoffice-trust-intake-raw-toggle-${s.id}`} onClick={() => toggleRaw(s.id)} title="Shows or hides the raw data this submission sent, for debugging." className="flex items-center gap-1 text-xs text-igc-goldText hover:text-igc-goldHover mt-2">
                {expandedRaw.includes(s.id) ? <CaretUp size={12} /> : <CaretDown size={12} />} Raw Data
              </button>
              {expandedRaw.includes(s.id) && (
                <pre className="bg-igc-surfaceLight text-igc-muted text-xs p-3 mt-2 whitespace-pre-wrap overflow-x-auto" data-testid={`backoffice-trust-intake-raw-${s.id}`}>
                  {JSON.stringify(s.raw_payload, null, 2)}
                </pre>
              )}
            </div>
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
}
